import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PermissionTypeEnum } from 'src/app/common/permission-enum';
import { getLongDate, getStringDate } from 'src/app/common/util';
import { SalesService } from 'src/app/services/sales.service';
import { VendorService } from 'src/app/services/vendor.service';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { TemplateInvoice } from 'src/app/templateInvoice/templateInvoice';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { ProductService } from 'src/app/services/product.service';
import { ActivatedRoute } from '@angular/router';
import { QueryParamsArService } from 'src/app/services/query-params-ar.service';
import { BillReceivableService } from 'src/app/services/bill-receivable.service';
import { CompanyService } from 'src/app/services/company.service';
import { HttpErrorResponse } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import { BankService } from 'src/app/services/bank.service';
import { ResponseObject } from 'src/app/models/response-object.model';
import { ModalDialogComponent } from 'src/app/components/modals/modal-dialog/modal-dialog.component';
import { ConfigurationInvoice, InvoiceItemModel, InvoiceTemplateModel} from 'src/app/models/invoice-template.model';
import { InvoiceType } from 'src/app/enums/invoice-type.enum';


@Component({
  selector: 'app-history-advance-payment',
  templateUrl: './history-advance-payment.component.html',
  styleUrls: ['./history-advance-payment.component.scss']
})
export class HistoryAdvancePaymentComponent implements OnInit {
  permissionType = PermissionTypeEnum;
  sales: any[] = [];
  pagination = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  }
  searchVendor = "";
  startDate = '';
  endDate = '';
  type = 0;
  loadingDownload: { [key: string]: boolean } = {};
  loadingPerfom: { [key: string]: boolean } = {};
  loadingData = false;
  invoiceDetail: any = null;
  todayDate = new Date();
  userId = null;
  detailing: { [key: string]: boolean } = {};

  advances: any[] = [];
  advanceSelected: any = null;
  advanceDetails: any = [];
  filteredAdvances: any[] = [];
  advanceSearch: string = "";
  showModal = false;
  currentCompany: any = null;

  constructor(
    private vendorService: VendorService,
    private toastService: ToastrService,
    private saleService: SalesService,
    private authService: AuthenticationService,
    private createService: TemplateInvoice,
    private warehouseService: WarehouseService,
    private productService: ProductService,
    private route: ActivatedRoute,
    private queryParamsService: QueryParamsArService,
    private billReceivableService: BillReceivableService,
    private companyService: CompanyService,
    private bankService: BankService,
  ) {
    const today = new Date();
    this.startDate = this.queryParamsService.getStringParam(this.route, "startDate", getStringDate(today));
    this.endDate = this.queryParamsService.getStringParam(this.route, "endDate", getStringDate(today));
    this.userId = JSON.parse(authService.getCurrentUser()).id;

    var permissions = authService.getPermissions();
    var getUserPosition = authService.getUserPosition();
  }

  ngOnInit(): void {
    this.type = this.queryParamsService.getNumberParam(this.route, "type", 0);
    this.currentCompany = JSON.parse(
      this.authService.getCurrentCompany()
    );
    this.getAdvances();
  }

  getAdvances() {
    this.bankService.getAdvances().subscribe({
      next: (response: ResponseObject) => {
        this.advances = response.data;
        this.advances.sort((a, b) => {
          const dateA = new Date(a.date).getTime();
          const dateB = new Date(b.date).getTime();

          if (dateB !== dateA) {
            return dateB - dateA;
          }

          return String(b.id).localeCompare(String(a.id));
        });
        this.pagination.total = this.advances;
        this.resetPagination();
      },
      error: (error: any) => {
        this.toastService.error("Error al obtener los avances, por favor recarga la página");
      }
    });
  }

  resetPagination() {
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.pageIndex = 0;
    this.pagination.lastElement = this.pagination.filter.length;
    this.pagination.startElement = 0;
  }

  getSalesByIntervalDate() {
    this.loadingData = true;

    const start = getLongDate(this.startDate);
    const end = getLongDate(this.endDate);

    this.advances.sort((a, b) => {
      const dateA = new Date(a.date).getTime();
      const dateB = new Date(b.date).getTime();

      if (dateB !== dateA) {
        return dateB - dateA;
      }

      return String(b.id).localeCompare(String(a.id));
    });

    this.pagination.total = this.advances;
    this.filtering();
    this.loadingData = false;
  }

  changeType() {
    const today = new Date();
    switch (parseInt(this.type + "")) {
      case 0:
        {
          this.endDate = getStringDate(today);
          this.startDate = getStringDate(today);
          break;
        }
      case 1:
        {
          this.endDate = getStringDate(today);
          today.setDate(today.getDate() - 7)
          this.startDate = getStringDate(today);
          break;
        }
      case 2:
        {
          this.endDate = getStringDate(today);
          today.setDate(1)
          this.startDate = getStringDate(today);
          break;
        }
      case 3:
        {
          const firstDayLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          const lastDayLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);

          this.startDate = getStringDate(firstDayLastMonth);
          this.endDate = getStringDate(lastDayLastMonth);
          break;
        }
      case 4:
        {
          this.endDate = getStringDate(today);
          today.setMonth(today.getMonth() - 2);
          this.startDate = getStringDate(today);
          break;
        }
      case 5:
        {
          this.endDate = getStringDate(today);
          today.setMonth(today.getMonth() - 3);
          this.startDate = getStringDate(today);
          break;
        }
    }
    this.queryParamsService.setParams(this.route, {
      type: this.type,
      startDate: this.startDate,
      endDate: this.endDate,
    });

    // this.getSalesByIntervalDate();
  }

  changeDate() {
    if (this.startDate && this.endDate) {
      var tempStart = new Date(this.startDate);
      var tempEnd = new Date(this.endDate);
      if (tempStart > this.todayDate || tempEnd > this.todayDate) {
        this.toastService.info("No puedes ingresar fechas más allá del día de hoy");
      } else {
        if (tempStart > tempEnd) {
          this.toastService.info("La fecha de inicio debe ser más lejana que la de final");
        } else {
          this.queryParamsService.setParams(this.route, {
            type: this.type,
            startDate: this.startDate,
            endDate: this.endDate,
          });
          this.getSalesByIntervalDate();
        }
      }
    }
  }

  filtering() {
    this.pagination.total = this.advances.filter((advance) => {

      const documentSearch =
        `${advance.docNumber ?? ''} ${advance.beneficiary ?? ''}`.toLowerCase();

      if (!documentSearch.includes(this.searchVendor.toLowerCase())) {
        return false;
      }


      return true;
    });

    this.resetPagination();
  }

  getFixedName(toFix: string) {
    var fixed = toFix;
    fixed = toFix.replace(/,+/g, ' ').replace(/\s+/g, ' ').trim();
    return fixed;
  }

  convertToString(date: number) {
    if (!date) {
      return '';
    }
    var tempDate = new Date(date);
    return getStringDate(tempDate);
  }

  detailingInvoice(item: any) {
    if (this.detailing[item.docId]) {
      return;
    }
    this.detailing[item.docId] = true;
    this.advanceSelected = item;
    this.bankService.getAdvanceDetails(item.sourceType, item.docId).subscribe({
      next: (response: any) => {
        const details = response.data ?? [];
        if (details.length == 0) {
          this.toastService.warning("Este anticipo no tiene detalles.");
          this.detailing[item.docId] = false;
          return;
        }

        this.advanceDetails = details;
        this.showModal = true;
        this.detailing[item.docId] = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener el detalle de la factura");
        this.detailing[item.docId] = false;
      }
    })
  }

  closeModal(modal: ModalDialogComponent) {
    modal.onClose();
  }

  subtotal(quantity: number, price: number) {
    return (quantity * price);
  }

  get total() {
    const total = this.advanceDetails.reduce((sum: number, item: any) => sum + (item.quantity * item.price), 0);
    return (total);
  }

  getAdvancePdfData(
    advance: any,
    details: any[],
    warehouse: any
  ): InvoiceTemplateModel {

    const templateGenerated = new InvoiceTemplateModel();

    templateGenerated.type = InvoiceType.ADVANCE;

    // Warehouse
    templateGenerated.warehouse = warehouse;

    // Moneda
    templateGenerated.currency = advance.currency ?? 0;

    // Información del cliente/beneficiario
    templateGenerated.client.name =
      advance.beneficiary ??
      advance.clientName ??
      '';

    templateGenerated.client.nit =
      advance.nit ??
      '';

    templateGenerated.client.address =
      advance.address ??
      '';

    // Información de empresa
    templateGenerated.seller.name =
      this.currentCompany?.companyName ?? '';

    templateGenerated.seller.nit =
      this.currentCompany?.nit ?? '';

    templateGenerated.seller.city = '';
    templateGenerated.seller.state = '';

    templateGenerated.seller.street =
      warehouse?.address ?? '';

    // Información del documento
    templateGenerated.invoice.date =
      advance.date
        ? new Date(advance.date).toISOString().split('T')[0]
        : '';

    templateGenerated.invoice.number =
      advance.docNumber ??
      advance.docId?.toString() ??
      advance.id?.toString() ??
      '';

    templateGenerated.invoice.serial = '';

    // Total de los productos
    const detailsTotal = (details ?? []).reduce(
      (sum: number, detail: any) =>
        sum +
        (Number(detail.quantity) || 0) *
        (Number(detail.price) || 0),
      0
    );

    templateGenerated.total = detailsTotal;

    // TOTAL ANTICIPO
    templateGenerated.totalAdvance =
      Number(advance.amount ?? 0);

    // Detalles
    (details ?? []).forEach(detail => {

      templateGenerated.items.push(
        new InvoiceItemModel(
          Number(detail.quantity) || 0,
          Number(detail.price) || 0,
          detail.productName ?? detail.description ?? '',
          0
        )
      );
    });

    return templateGenerated;
  }

  async createAdvancePDF(
    advance: any,
    details: any[],
    warehouse: any
  ) {

    const invoiceDataNew = this.getAdvancePdfData(
      advance,
      details,
      warehouse
    );

    // Forzamos template 1 para anticipos
    const configurationInvoice = new ConfigurationInvoice(
      1,
      warehouse['fcolor'],
      warehouse['scolor'],
      warehouse['tcolor'],
      warehouse['slogan']
    );

    // Primero intentar logo de warehouse
    if (warehouse?.logo) {

      this.createService.selectTemplate(
        configurationInvoice,
        invoiceDataNew,
        warehouse.logo
      );

      return;
    }

    // Si no tiene logo de warehouse,
    // usar logo de la empresa
    if (
      this.currentCompany?.companyLogo &&
      !this.currentCompany.companyLogo.includes(
        "/images/company-avatar2.png"
      )
    ) {

      this.createService.selectTemplate(
        configurationInvoice,
        invoiceDataNew,
        this.currentCompany.companyLogo
      );

      return;
    }

    // Sin logo
    this.createService.selectTemplate(
      configurationInvoice,
      invoiceDataNew,
      null
    );
  }

  downloadAdvance(item: any) {

    if (this.loadingDownload[item.docId]) {
      return;
    }

    this.loadingDownload[item.docId] = true;

    this.bankService.getAdvanceDetails(
      item.sourceType,
      item.docId
    ).subscribe({

      next: (response: ResponseObject) => {

        const details = response.data ?? [];

        if (details.length === 0) {

          this.toastService.warning(
            "Este anticipo no tiene detalles."
          );

          this.loadingDownload[item.docId] = false;

          return;
        }

        const warehouseId =
          details[0]?.warehouseId ??
          item.warehouseId;

        if (!warehouseId) {

          this.toastService.error(
            "No se pudo determinar la bodega del anticipo."
          );

          this.loadingDownload[item.docId] = false;

          return;
        }

        this.warehouseService
          .getWarehouses()
          .subscribe({

            next: (warehouseResponse: any) => {

              const warehouses =
                warehouseResponse.data ?? [];

              const warehouse =
                warehouses.find(
                  (w: any) =>
                    w.id == warehouseId
                );

              if (!warehouse) {

                this.toastService.error(
                  "No se encontró la bodega del anticipo."
                );

                this.loadingDownload[item.docId] = false;

                return;
              }

              // Normalizar logo como haces en ventas
              if (warehouse.logo) {

                warehouse.logo =
                  "https://s3.amazonaws.com/rrhh-images/warehouse/logos/" +
                  warehouse.logo;
              }

              this.createAdvancePDF(
                item,
                details,
                warehouse
              );

              this.loadingDownload[item.docId] = false;
            },

            error: () => {

              this.toastService.error(
                "Error al obtener la bodega."
              );

              this.loadingDownload[item.docId] = false;
            }
          });
      },

      error: () => {

        this.toastService.error(
          "Error al obtener los detalles del anticipo."
        );

        this.loadingDownload[item.docId] = false;
      }
    });
  }
}
